module.exports = __webpack_public_path__ + "static/onTheIssues_Environment-da37a269f97768012cccb9ebfd7ca4e9.jpg";